module.exports = __webpack_public_path__ + "static/img/2.1a53128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/2.png
// module id = GdCC
// module chunks = 0